import React from "react";
import "./index.css";
import { siteContent } from "../content";

const Beneficios = () => {
  const beneficios = siteContent.benefits.items;
  return (
    <div className="section relative">
      <div className="container-lg flex flexCol flexCenter">
        <h5 className="textCenter">{siteContent.benefits.eyebrow}</h5>
        <h2 className="textCenter titleSec">
          {siteContent.benefits.title}
        </h2>
        <p className="textCenter pSec">{siteContent.benefits.description}</p>
        <div className="beneficios flex flexCol flexCenter ">
          {beneficios.map((beneficio, index) => (
            <div key={index} className="flex checkItems">
              <span className="checkIcon" aria-hidden="true">+</span>
              <span className="checktext">{beneficio}</span>
            </div>
          ))}
        </div>
        <a
          href="#form"
          className="btn"
        >
          {siteContent.benefits.cta}
        </a>
      </div>
    </div>
  );
};

export default Beneficios;
